import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnChanges,
} from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { appState } from 'src/app/shared/interfaces/appState.interface';
import { DateChecker } from '@shared-logic/utils';
import { PriceValidator } from 'src/app/shared/price';
import { ToFixValidator } from 'src/app/shared/to-fix';
import { PriceBoard } from 'src/app/components/board/price/price-board';
import { Price } from '@shared-logic/prices';
import { setPricesSelected } from 'src/app/redux/actions/price.action';
import { selectPrice } from 'src/app/shared/price';
import { OPTION } from 'src/app/components/board/options/options.component';
import { setErrorStruct } from 'src/app/redux/actions/options.action';

@Component({
  selector: 'app-price-table-comercial',
  templateUrl: './price-table-comercial.component.html',
  styleUrls: [
    '../price-table.component.scss',
    './../../../../../shared/styles/board.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PriceTableComercialComponent
  extends PriceBoard
  implements OnInit, OnDestroy {

  // private MAX_SELECTIONS = 12;
  constructor(
    store: Store<appState>,
    router: Router,
    date: DateChecker,
    priceV: PriceValidator,
    toFixV: ToFixValidator,
    cdr: ChangeDetectorRef
  ) {
    super(store, router, date, priceV, toFixV, cdr);
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  override getDeliveryPeriod(price: Price) {
    if (this.isChild(price)) {
      return '';
    }
    return this.priceV.getDeliveryPeriod(price);
  }

  //-----------------------------------------------\\
  emitAction(action: string) {
    switch (action) {
      case OPTION.SELECT_ALL:
        this.checkedAllItems();
        break;
    }
  }

  //---------- CHECKED, SELECT AND FILTER ----------\\
  checkedAllItems() {
    this.store.dispatch(
      setPricesSelected({
        prices: this.getCheckedAll() ? [] : this.pricesWithPipe,
      })
    );
  }

  getCheckedAll() {
    return (
      JSON.stringify(this.pricesWithPipe) == JSON.stringify(this.pricesSelected)
    );
  }

  selectPrice(price: Price, event?: Event) {
    const alreadySelected = this.priceV.isPriceInPriceList(price, this.pricesSelected);
    /* if (!alreadySelected && this.pricesSelected.length >= this.MAX_SELECTIONS) {
      event?.preventDefault();
      this.store.dispatch(setErrorStruct({
        error: {
          color: '#fff',
          isVisible: true,
          message: `Solo podés seleccionar un máximo de ${this.MAX_SELECTIONS} condiciones.`
        }
      }));
      return;
    } */
    selectPrice(price, this.pricesSelected, this.store);
  }

  isPriceInPriceList(price: Price) {
    return this.priceV.isPriceInPriceList(price, this.pricesSelected);
  }
}
